import { render } from "./ProjectBar.vue?vue&type=template&id=0d9c058c&ts=true"
import script from "./ProjectBar.vue?vue&type=script&lang=ts"
export * from "./ProjectBar.vue?vue&type=script&lang=ts"

import "./ProjectBar.vue?vue&type=style&index=0&id=0d9c058c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__